import React from 'react';

const ArrowDown = () => {
	return (
		<svg width='17' height='17' viewBox='0 0 17 17' fill='none' xmlns='http://www.w3.org/2000/svg'>
			<path
				d='M7.90947 11.1663C8.21368 11.4705 8.76842 11.4705 9.07263 11.1663L12.2937 7.94526C12.6158 7.62316 12.6158 7.10421 12.2937 6.78211C11.9716 6.46 11.4526 6.46 11.1305 6.7821L8.5 9.41263L5.86947 6.7821C5.70842 6.62105 5.49368 6.53158 5.27895 6.53158C5.06421 6.53158 4.84947 6.62105 4.68842 6.7821C4.36632 7.10421 4.36632 7.62316 4.68842 7.94526L7.90947 11.1663Z'
				fill='#323467'
			/>
			<path
				d='M8.5 17C13.1884 17 17 13.1884 17 8.5C17 3.81158 13.1884 1.15297e-06 8.5 7.43094e-07C3.81158 3.33219e-07 -3.33219e-07 3.81158 -7.43093e-07 8.5C-1.15297e-06 13.1884 3.81158 17 8.5 17ZM8.5 1.64632C12.2758 1.64632 15.3537 4.72421 15.3537 8.5C15.3537 12.2758 12.2758 15.3537 8.5 15.3537C4.72421 15.3537 1.64631 12.2758 1.64632 8.5C1.64632 4.72421 4.72421 1.64632 8.5 1.64632Z'
				fill='#323467'
			/>
		</svg>
	);
};

export default ArrowDown;
